import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("h2", { class: "text-h5 mb-4" }, "System Support and Maintenance", -1 /* HOISTED */)
            ])),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "text-left",
                hover: "",
                link: "",
                to: { path: '/SSAM/hovers' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        size: "40"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode("mdi-cursor-default-click")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("Hover Management")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Manage hover options for policy navigation")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" Add, view, and manage default and user-specific hover options for policy processing, claims, and receivables. ")
                    ])),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "text-left",
                hover: "",
                link: "",
                to: { path: '/SSAM/groups' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        size: "40"
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("mdi-account-group")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("Group Management")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("Manage groups and user assignments")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Create, update, and delete authorization groups. Assign and remove users from groups. ")
                    ])),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "text-left",
                hover: "",
                link: "",
                to: { path: '/SSAM/menus' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        size: "40"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("mdi-menu")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("Command Center Menus")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("Manage menu items and navigation")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" Add, update, and delete command center menu items for POINT and Operation applications. ")
                    ])),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "text-left",
                hover: "",
                link: "",
                to: { path: '/SSAM/rsm-updates' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        size: "40"
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("mdi-account-switch")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("RSM Management")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => _cache[15] || (_cache[15] = [
                          _createTextVNode("Manage regional sales assignments")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                      _createTextVNode(" Add, update, and delete DMM/RSM assignments, sales fields, and region descriptions. ")
                    ])),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "text-left",
                hover: "",
                link: "",
                to: { path: '/SSAM/underwriters' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_item, null, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        size: "40"
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("mdi-account-tie")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, null, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("Underwriter Management")
                        ])),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_subtitle, null, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("Manage and provision underwriters")
                        ])),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode(" View all underwriters and provision new underwriter accounts with group profiles. ")
                    ])),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}